export function isBrowser(): boolean {
  return typeof window !== "undefined";
}

export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizeEmail(email));
}

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

export function isEmailAlreadyExistsError(message: string): boolean {
  return /already exists|email.*registered|409/i.test(message);
}

export function isEmailAlreadyVerifiedError(message: string): boolean {
  return /already verified/i.test(message);
}

import { ApiClientError } from "@/src/utils/apiError";

export function getApiErrorMessage(error: unknown, fallback = "Something went wrong. Please try again."): string {
  if (typeof error === "string") return error;
  if (error instanceof ApiClientError) return error.message;
  if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === "string" && message.trim()) return message;
  }
  return fallback;
}

export { getApiErrorTitle } from "@/src/utils/apiError";

export function toHomeownerDisplayName(user: {
  firstName?: string;
  lastName?: string;
  email?: string;
}): string {
  const name = [user.firstName, user.lastName].filter(Boolean).join(" ").trim();
  return name || user.email || "User";
}

/** RFC 4122 UUID (any version) — backend may reject CUID-style ids. */
export function isUuid(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value.trim(),
  );
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function toInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}
